import { useReducedMotion } from 'framer-motion';
import { useEffect, useState } from 'react';

import {
  resolveVestingGraphIntroPlayingMs,
  VESTING_GRAPH_INTRO_START_DELAY_MS,
  VestingGraphIntroPhase,
} from '../model/vesting-graph.intro';

/**
 * Plays once per chart mount, after the plot width is known. Resize must not restart it —
 * Recharts would otherwise grow the series again every time the shell is measured.
 */
export const useVestingGraphIntro = ({
  layoutReady,
  pointCount,
}: {
  layoutReady: boolean;
  pointCount: number;
}) => {
  const prefersReducedMotion = useReducedMotion();
  const [phase, setPhase] = useState<VestingGraphIntroPhase>('pending');

  useEffect(() => {
    if (phase !== 'pending') return undefined;
    if (prefersReducedMotion) {
      setPhase('done');
      return undefined;
    }
    if (!layoutReady) return undefined;

    const startId = window.setTimeout(
      () => setPhase('playing'),
      VESTING_GRAPH_INTRO_START_DELAY_MS,
    );

    return () => window.clearTimeout(startId);
  }, [layoutReady, phase, prefersReducedMotion]);

  useEffect(() => {
    if (phase !== 'playing') return undefined;

    const doneId = window.setTimeout(
      () => setPhase('done'),
      resolveVestingGraphIntroPlayingMs(pointCount),
    );

    return () => window.clearTimeout(doneId);
  }, [phase, pointCount]);

  return phase;
};
